import { environment } from '@environments/environment'

const isApp = (subDomain: string) => environment.appSubdomain.length && subDomain.includes(environment.appSubdomain)

export const domainName = (locations?: string): string => {
  const locationDomain = locations || location.host
  const locationDomainArray = locationDomain.split('.')
  const subDomain = locationDomainArray[0]

  if (isApp(subDomain)) {
    return locationDomainArray.slice(1).join('.')
  }

  return locationDomain
}

export const subdomainByEnv = (subdomainEnv: string): string => {
  const subdomainName = <string>environment[subdomainEnv]
  const subDomainLength = subdomainName.length
  const isProduction = process.env.NODE_ENV !== 'development'

  const locationDomain = location.host
  const currentSubDomain = locationDomain.split('.')[0]

  if (isProduction && subDomainLength && isApp(currentSubDomain)) {
    return `${currentSubDomain.replace(environment.appSubdomain, subdomainName)}.`
  } else if (environment.debugProd && subDomainLength) {
    return `${subdomainName}.`
  }

  return `${subdomainName}.`
}

export const goSubdomainByEnv = (): string => {
  const goApiSubdomain = <string>environment['goApiSubdomain']
  const subDomainLength = goApiSubdomain?.length
  const isProduction = process.env.NODE_ENV !== 'development'

  const locationDomain = location.host
  const currentSubDomain = locationDomain.split('.')[0]

  if (isProduction && subDomainLength && isApp(currentSubDomain)) {
    return `${currentSubDomain.replace(environment.appSubdomain, goApiSubdomain)}.`
  } else if (environment.debugProd && subDomainLength) {
    return `${goApiSubdomain}.`
  }

  return `${goApiSubdomain}.`
}
